import { makeStyles } from "@material-ui/styles";
import ColorButton from "components/common/ColorButton";
import React from "react";

const useStyles = makeStyles(() => ({
  root: {
    borderRadius: 8,
    width: 82,
  },
  icon: {
    marginRight: 8,
  },
}));

export default function EditButton({ onClick, ...props }) {
  const classes = useStyles();

  return (
    <ColorButton
      {...props}
      className={classes.root}
      onClick={onClick}
      fullWidth={false}
      variant="outlined"
    >
      <img src="/assets/edit.svg" alt="edit" className={classes.icon} />
      {props.title || "Edit"}
    </ColorButton>
  );
}
